import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { defaultTo, compose } from 'ramda';
import { withFormik } from 'formik';
import Select from 'react-select';

import magic from '../../util/magic';
import { handleError, handleSuccess } from '../../util/forms';
import registrationActions from '../../redux/registration';
import { apiGetEmailDropdownsForCategory } from '../../api/email';

import Modal from '../Modal';
import EditField from '../Forms/EditField';
import { apiRejectRegistration } from '../../api/registration';
import * as yup from 'yup';

const mapDispatch = {
  ...registrationActions,
};

class RejectRegistrationModal extends Component {
  static propTypes = {
    registration: PropTypes.object,
  };

  state = {
    fetchMessageDropdown: false,
    messageDropdown: [],
  };

  loadingMessageDropdown = false;

  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState && !prevState.show && nextProps.show && nextProps.resetForm) {
      nextProps.resetForm();
      return { show: defaultTo(false, nextProps.show), fetchMessageDropdown: true };
    }

    return { show: defaultTo(false, nextProps.show) };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.fetchMessageDropdown && !this.loadingMessageDropdown) {
      const isFinalApproval = this.props.registration.status == magic.finalApproval;
      this.loadingMessageDropdown = true;

      apiGetEmailDropdownsForCategory(
        isFinalApproval ? magic.emailCertificationRejection : magic.emailRegistrationRejection,
      )
        .then(({ data }) => this.setState({ messageDropdown: data.options, fetchMessageDropdown: false }))
        .catch((err) => console.error(err))
        .then(() => (this.loadingMessageDropdown = false));
    }
  }

  render() {
    const {
      onHide,
      values,
      errors,
      handleBlur,
      handleChange,
      handleSubmit,
      isSubmitting,
      isValid,
      registration,
      setFieldValue,
      show,
      status,
    } = this.props;
    const { messageDropdown } = this.state;
    const isFinalApproval = registration.status == magic.finalApproval;
    const isExperienceApproval = registration.status == magic.experienceApproval;
    const steps =
      isFinalApproval || isExperienceApproval
        ? [
            { value: 'experience', label: 'Experience' },
            { value: 'employment_verification', label: 'Employment Verification' },
            { value: 'certificate_name', label: 'Certificate Name' },
            { value: 'professional_info', label: 'Professional Info' },
            { value: 'preferences', label: 'Preferences' },
            { value: 'code_of_ethics', label: 'Code Of Ethics' },
            { value: 'final_summary', label: 'Summary' },
          ]
        : [
            { value: 'pathway', label: 'Pathway' },
            { value: 'documentation', label: 'Supporting Documentation' },
            { value: 'course_materials', label: 'Course Materials' },
            { value: 'shipping', label: 'Shipping' },
            { value: 'membership', label: 'Membership' },
            { value: 'donation', label: 'Donation' },
            { value: 'summary', label: 'Pay & Review' },
          ];

    return (
      <Modal show={show} onHide={onHide} title="Reject Registration">
        <form>
          <Modal.Body>
            <EditField
              as={Select}
              bare
              block
              multi
              status={status}
              label="Why is the registration rejected?"
              name="messageDropdown"
              onChange={(value) =>
                setFieldValue(
                  'selectedMessages',
                  value.map((choice) => choice.value),
                )
              }
              value={values.selectedMessages}
              options={messageDropdown.map((option) => ({ value: option.id, label: option.title }))}
              error={errors.messageDropdown}
            />
            <EditField
              block
              as="textarea"
              name="message"
              status={status}
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.message}
              error={errors.message}
            />
            <label>Set user step to:</label>
            <Select
              simpleValue
              onChange={(value) => setFieldValue('step', value)}
              options={steps}
              value={values.step}
            />
          </Modal.Body>
          <Modal.Footer>
            <button type="button" className="btn btn-secondary" onClick={onHide}>
              Close
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={!isValid || isSubmitting}
              onClick={handleSubmit}
            >
              Send
            </button>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }
}

export default compose(
  connect(null, mapDispatch),
  withFormik({
    handleSubmit: (payload, formProps) => {
      const { props } = formProps;

      apiRejectRegistration(props.registration.id, payload)
        .then(({ data }) => props.updateRegistration(data))
        .then(() => handleSuccess(formProps))
        .then(props.onHide)
        .catch((err) => handleError(formProps, err));
    },
    mapPropsToValues: ({ registration }) => ({
      selectedMessages: [],
      message: '',
      step: defaultTo('', registration.step),
    }),
    validationSchema: () =>
      yup.object().shape({
        step: yup.string().required('You must select a step'),
      }),
    isInitialValid: ({ initialValues, validationSchema }) => validationSchema().isValidSync(initialValues),
    validateOnChange: true,
  }),
)(RejectRegistrationModal);
